import type { EventFormValues } from './components/event-form-fields'
import type { EventInput } from './types.graphql'

/** The form as the API wants it. Shared by create, add and edit. */
export const eventFormToInput = (values: EventFormValues): EventInput => ({
  startsAt: values.startsAt.toISOString(),
  endsAt: values.endsAt ? values.endsAt.toISOString() : null,
  location: values.location,
  registrationDeadline: values.registrationDeadline
    ? values.registrationDeadline.toISOString()
    : null,
  questions: values.questions.map(question => ({
    // A question the organiser just added has no id yet; the backend keeps the
    // ones that carry theirs and drops whatever is missing from the list.
    ...(question.id ? { id: question.id } : {}),
    label: question.label,
    type: question.type,
    required: question.required,
  })),
})
